import * as toastr from 'toastr';
import 'toastr/build/toastr.css';

toastr.options.preventDuplicates = true;
toastr.options.timeOut = 4000;
window.toastr = toastr;
